"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const prop_types_1 = require("prop-types");
const intl_1 = require("@kyruus/intl");
const moment_1 = __importDefault(require("moment"));
const add_to_calendar_1 = __importDefault(require("@kyruus/add-to-calendar"));
const utils_1 = require("../../lib/utils");
const messages_1 = __importDefault(require("../../lib/messages"));
const propTypes = {
    provider: (0, prop_types_1.shape)({
        name: (0, prop_types_1.shape)({ id: prop_types_1.string, name: { full: prop_types_1.string, full_name: prop_types_1.string } }),
        degrees: (0, prop_types_1.arrayOf)((0, prop_types_1.shape)({ name: prop_types_1.string })),
        contacts: (0, prop_types_1.shape)({ contact_type: prop_types_1.string })
    }).isRequired,
    appointment: (0, prop_types_1.shape)({ start_datetime: prop_types_1.string }).isRequired,
    location: (0, prop_types_1.shape)({
        id: prop_types_1.string,
        name: prop_types_1.string,
        street1: prop_types_1.string,
        street2: prop_types_1.string,
        suite: prop_types_1.string,
        city: prop_types_1.string,
        state: prop_types_1.string,
        zip: prop_types_1.string
    }).isRequired,
    intl: (0, prop_types_1.shape)({
        locale: prop_types_1.string.isRequired,
        formatMessage: prop_types_1.func.isRequired
    }).isRequired,
    onEventClick: prop_types_1.func
};
const AddToCalendarButton = ({ provider, appointment, location, intl, onEventClick }) => {
    let startTime = (0, moment_1.default)(appointment.start_datetime);
    // hard-coding 30 minutes past the start per KENG-10980
    let endTime = (0, moment_1.default)(appointment.start_datetime).add(30, 'minute');
    return (react_1.default.createElement(add_to_calendar_1.default, { onEventClick: onEventClick, text: intl.formatMessage(messages_1.default.addToCalendar), event: {
            title: intl.formatMessage(messages_1.default.calendarEventTitle, {
                provider_name: (0, utils_1.formatProviderName)(provider)
            }),
            details: intl.formatMessage(messages_1.default.calendarEventDetails, {
                provider_name: (0, utils_1.formatProviderName)(provider),
                phone_number: (0, utils_1.getMainContactNumber)(provider)
            }),
            location: (0, utils_1.formatLocation)(location),
            start: startTime.toISOString(),
            end: endTime.toISOString()
        }, modeLabels: {
            apple: null,
            google: null,
            outlook: null,
            yahoo: null
        }, buttonMode: "secondary" }));
};
AddToCalendarButton.propTypes = propTypes;
exports.default = (0, intl_1.injectIntl)(AddToCalendarButton);
//# sourceMappingURL=AddToCalendarButton.js.map